/*eslint no-sequences: 0*/
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import jwt_decode from 'jwt-decode';
import request, { NodeURL, client, socket_chat, socket_notify } from '../api/api';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import unverified_img from '../../src/images/home/expire.svg';
import tick_img from '../../src/images/home/tick.svg';
import { Form, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
class CandidateLogin extends Component {
   state = {
      email: '',
      password: '',
      agency_company_name: '',
      agencyID: '',
      emaillists: [],
      disabled: true,
      loader: false,
      invalidemail: false,
      login_loder: false,
      showPassword: false,
      logo_loder: false,
      error: false,
      email_verified: true,
      showResendModal: false,
      ackResendModal: false,
      ackNewEmail: false,
      userId: '',
      emailVerifiedValue: '',
      spinner : false,
      emailNew: '', // Input value
      emailError: '', // Validation error
      isDirty: false, // Tracks if the input has been modified
      isValid: false, // Tracks if the input is valid
   };

   onChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
   };

   componentDidMount() {
      socket_chat.on('roomcreated', (data) => {
         console.log('roomcreated success candidate');
      });
      socket_chat.on('disconnect', () => {
         console.log('disconnect success candidate');
      });
      socket_chat.on('connect', () => {
         const token = localStorage.getItem('APUSEC');
         if (token && token.user_id) {
            socket_chat.emit('join network', {
               user: token.user_id,
               collections: 'employees',
            });
         }
         console.log('connect connect connect employee');
      });
      socket_notify.on('connect', () => {
         const token = localStorage.getItem('APUSEC');
         if (token && token.user_id) {
            socket_notify.emit('join network', {
               user: token.user_id,
               collections: 'employees',
            });
         }
         console.log('connect connect connect employee');
      });
      const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
      request({
         url: '/site/agencies',
         method: 'POST',
      })
         .then((res) => {
            this.setState({ logo_loder: true });
            const filteredlist = res.response.result && res.response.result.filter((list) => String(list.domain) === String(subdomain));
            this.setState(
               {
                  agency_company_logo: filteredlist[0] && filteredlist[0].company_logo,
                  agency_company_name: filteredlist[0] && filteredlist[0].company_name,
                  agencyID: filteredlist[0] && filteredlist[0]._id,
               },
               () => {
                  this.setState({ logo_loder: false, disabled: false });
               },
            );
            this.setState({ agencylist: res.response.result });
            request({
               url: '/site/settings',
               method: 'POST',
            })
               .then((res) => {
                  if (res.status === 1) {
                     this.setState({ logo_loder: true });
                     setTimeout(() => {
                        this.setState({ sitesettings_logo: res.response.settings.logo || {} }, () => {
                           this.setState({ logo_loder: false, disabled: false });
                        });
                     }, 2000);
                  } else if (res.status === 0) {
                     toast.error(res.response);
                  }
               })
               .catch((err) => {
                  toast.error(err);
                  this.setState({ disabled: false });
               })
               .finally(() => {
                  this.setState({ logo_loder: false });
               });
         })
         .finally(() => {
            this.setState({ logo_loder: false });
         });
      if (this.props.location.state === true) {
         return toast.success('Registration Completed Successfully!  Please Check Your Mail'), this.props.history.push({ state: false });
      }
      const tokenAgency = localStorage.getItem('APUSEC');
      if (tokenAgency) {
         const token = jwt_decode(tokenAgency);
         if (token && token.role) {
            switch (token.role) {
               case 'agency':
                  if (token.subscription === 1) {
                     setTimeout(() => {
                        this.props.history.push('/dashboard/default');
                        window.location.reload();
                     }, 200);
                  } else if (token.subscription === 0) {
                     setTimeout(() => {
                        this.props.history.push('/dashboard/default');
                        window.location.reload();
                     }, 200);
                  }
                  break;
               default:
            }
         }
      }
      if (this.props.location.state === 'notify') {
         toast.info('Logged Out!');
         this.props.history.push({ state: '' });
      }
   }

   agencynodifytoastId = 'AgencyLogin';
   agencynodify() {
      if (!toast.isActive(this.agencynodifytoastId)) {
         this.agencynodifytoastId = toast.success('Registration Completed Successfully!  Please Check Your Mail');
      }
   }
   openInNewTab = (href) => {
      Object.assign(document.createElement('a'), {
         target: '_self',
         href,
      }).click();
   };
   OnFormSubmit = (e) => {
      e.preventDefault();

      const loginform = {
         email: this.state.email,
         password: this.state.password,
         agencyID: this.state.agencyID,
      };
      this.setState({
         loader: true,
      });
      request({
         url: '/employeelogin',
         method: 'POST',
         data: loginform,
      })
         .then((res) => {
            this.setState({ loader: false });
            if (res.status === 1) {
               if (res.response && String(res.response.role_type) === String('candidate')) {
                  this.setState({
                     email_verified: res.response.email_verified,
                     emailVerifiedValue: res.response.emailVerifiedValue,
                     emailNew: this.state.email,
                     userId: res && res.response && res.response.userId ? res.response.userId : '',
                  });
               }
               let tokenEmployee;
               if (res.response && String(res.response.role_type) === String('employees')) {
                  let hostname = window.location.hostname,
                     protocol = window.location.protocol,
                     port = window.location.port;
                  if (hostname.includes('localhost')) {
                     toast.info(res.response.message);
                     setTimeout(() => {
                        window.location.href = `${protocol}//${hostname}:${port}/employee/user/dashboard`;
                     }, 500);
                     return;
                  } else {
                     toast.info(res.response.message);
                     setTimeout(() => {
                        window.location.href = `${protocol}//${hostname}/employee/user/dashboard`;
                     }, 500);
                     return;
                  }
               }
               if (res.response.auth_token) {
                  tokenEmployee = jwt_decode(res.response.auth_token);
                  if (tokenEmployee && tokenEmployee.user_id) {
                     localStorage.setItem('avatar', tokenEmployee.avatar);
                     socket_chat.emit('connection');
                     socket_chat.emp_id = tokenEmployee.user_id;
                     socket_chat.emit('join network', {
                        user: tokenEmployee.user_id,
                        collections: 'employees',
                     });
                     socket_notify.emit('join network', {
                        user: tokenEmployee.user_id,
                        collections: 'employees',
                     });
                  }
               }
               localStorage.setItem('APUSEC', res.response.auth_token);
               localStorage.setItem('isAuthenticated', true);
               if (res.response && +res.response.application_status && +res.response.application_status === 3) {
                  if (String(res.response.role_type) === String('employees')) {
                     let hostname = window.location.hostname,
                        protocol = window.location.protocol,
                        port = window.location.port;
                     if (hostname.includes('localhost')) {
                        toast.info(res.response.message);
                        window.location.href = `${protocol}//${hostname}:${port}/employee`;
                     } else {
                        toast.info(res.response.message);
                        window.location.href = `${protocol}//${hostname}/employee`;
                     }
                  } else {
                     toast.success('You have logged in successfully');
                     client.defaults.headers.common['Authorization'] = res.response.auth_token;
                     var referrer = document.referrer;
                     if (referrer && referrer.length > 2) {
                        if (String(referrer).includes('/profile/editprofile?')) {
                           return window.history.back();
                        }
                     }
                     if (res.response && String(res.response.role_type) === String('candidate') && res.response.email_verified) {
                        setTimeout(() => {
                           this.props.history.push({
                              pathname: '/dashboard/default',
                              state: true,
                           });
                        }, 1000);
                     }
                  }
               } else {
                  toast.success('You have logged in successfully');
                  client.defaults.headers.common['Authorization'] = res.response.auth_token;
                  var referrer = document.referrer;
                  if (referrer && referrer.length > 2) {
                     if (String(referrer).includes('/profile/editprofile?')) {
                        return window.history.back();
                     }
                  }
                  if (res.response && String(res.response.role_type) === String('candidate') && res.response.email_verified) {
                     setTimeout(() => {
                        this.props.history.push({
                           pathname: '/dashboard/default',
                           state: true,
                        });
                        this.setState({
                           loader: false,
                        });
                     }, 1000);
                  }
               }
            } else if (res.status === 0) {
               this.setState({
                  loader: false,
               });
               toast.error(res.response);
            }
         })
         .catch((err) => {
            this.setState({
               loader: false,
            });
            toast.error(err);
         });
   };

   deactivatenodifytoastId = 'AgencyLogin';

   deactivatenodify() {
      if (!toast.isActive(this.deactivatenodifytoastId)) {
         this.deactivatenodifytoastId = toast.error('Deactivated!');
      }
   }

   logoutmsgtoastId = 'AgencyLogin';
   logoutmsg = () => {
      if (!toast.isActive(this.logoutmsgtoastId)) {
         this.logoutmsgtoastId = toast.info('Logged Out!');
      }
   };

   onShowPassword = () => {
      var x = document.getElementById('password');
      if (x.type === 'password') {
         x.type = 'text';
         this.setState({
            showPassword: true,
         });
      } else {
         x.type = 'password';
         this.setState({
            showPassword: false,
         });
      }
   };

   forget_pass = (e) => {
      e.preventDefault();
      this.props.history.push({ pathname: '/forgot/password' });
   };

   handleResendVerification = async () => {
      try {
         this.setState({
            spinner: true,
         });
         const res = await request({
            url: `/candidate/emailverification/redo-validation?agencyId=${this.state.agencyID}&userId=${this.state.userId}`,
            method: 'GET',
         });

         if (res.status === 1) {
            toast.success(res.response);
            this.setState({
               showResendModal: true,
               email_verified: true,
               spinner: false,
            });
         } else if (res.status === 0) {
            toast.error(res.response);
            this.setState({
               showResendModal: false,
               email_verified: false,
               spinner: false,
            });
         }
      } catch (err) {
         toast.error(err.response?.data?.message || 'An error occurred while resending the link.');
         this.setState({
            showResendModal: false,
            email_verified: false,
            spinner: false,
         });
      }
   };

   closeSent = () => {
      setTimeout(() => {
         this.setState({
            email_verified: true,
            showResendModal: false,
         });
      }, 1000);
   };

   handleChange = (e) => {
      const { value } = e.target;
      let emailError = '';
      let isValid = true;

      // Validation logic
      if (!value) {
         emailError = 'This is a required field.';
         isValid = false;
      } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/.test(value)) {
         emailError = 'Please enter a valid email.';
         isValid = false;
      }

      this.setState({
         emailNew: value,
         emailError,
         isDirty: true,
         isValid,
      });
   };

   handleSubmit = async (e) => {
      e.preventDefault();
      const { emailNew, isValid, userId } = this.state;

      if (!isValid) {
         console.error('Form is not valid');
         return;
      }

      const dataNew = {
         agencyId: this.state.agencyID,
         newEmail: emailNew,
         userId,
      };

      this.setState({ spinner: true });
      try {
         const res = await request({
            url: `/candidate/email-verification/resubmit-email`,
            method: 'POST',
            data: dataNew,
         });

         if (+res.status === 1) {
            toast.success(res.response);
            this.setState({
               spinner: false,
               ackResendModal: false,
               email_verified: true,
               ackNewEmail: true,
               showResendModal: false,
            });
         } else {
            toast.error(res.response);
            this.setState({
               spinner: false,
               ackResendModal: true,
               email_verified: true,
               ackNewEmail: false,
               showResendModal: false,
            });
         }
      } catch (err) {
         console.error('Error during email verification resubmission:', err);
         toast.error(err);
         this.setState({
            spinner: false,
            ackResendModal: true,
            email_verified: true,
            ackNewEmail: false,
            showResendModal: false,
         });
      }
   };

   render() {
      const {
         login_loder,
         logo_loder,
         email,
         password,
         agency_company_name,
         email_verified,
         showResendModal,
         ackResendModal,
         ackNewEmail,
         emailNew,
         emailError,
         isDirty,
         isValid,
         spinner,
      } = this.state || {};
      const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
      const logourl = this.state.agency_company_logo ? this.state.agency_company_logo : this.state.sitesettings_logo;

      return (
         <>
            {this.state.loader ? (
               <div
                  className="loader-box"
                  style={{
                     margin: '0px',
                     padding: '0px',
                     position: 'fixed',
                     right: '0px',
                     top: '0px',
                     width: '100%',
                     height: '100%',
                     backgroundColor: 'rgb(102, 102, 102)',
                     zIndex: '30001',
                     opacity: '0.8',
                     justifyContent: 'center',
                  }}
               >
                  <span className="rotate dashed colored"></span>
               </div>
            ) : null}
            {email_verified && !showResendModal && !ackResendModal && !ackNewEmail && (
               <section className="section login-spaces">
                  <div className="container">
                     <div className="row form">
                        <div className="agency-boxes login-cont">
                           <div className="box-width">
                              <div className="employee-forms">
                                 <div className="new-agency-body">
                                    <div className="new-agency-login">
                                       {logo_loder ? (
                                          <div className="home-loader">
                                             <i className="fa fa-spinner fa-spin fa-5x" />{' '}
                                          </div>
                                       ) : (
                                          <img src={`${NodeURL}/${logourl}`} alt="" />
                                       )}
                                    </div>
                                    <h4>{agency_company_name} Candidate Portal</h4>
                                    <h6>Login with your username and password </h6>

                                    <form className="theme-form" onSubmit={this.OnFormSubmit}>
                                       <div className="form-group">
                                          {/* <label className="col-form-label pt-0">
                                Username
                              </label> */}
                                          <input
                                             className="form-control"
                                             type="text"
                                             name="email"
                                             value={email}
                                             onChange={this.onChange}
                                             placeholder="Enter email or username"
                                          />
                                       </div>
                                       <div className="form-group">
                                          {/* <label className="col-form-label">Password</label> */}
                                          <input
                                             className="form-control"
                                             type="password"
                                             name="password"
                                             value={password}
                                             onChange={this.onChange}
                                             placeholder="Enter Password"
                                          />
                                       </div>
                                       <p className="forget_password">
                                          {' '}
                                          <a
                                             className="btn-link text-primary"
                                             style={{ cursor: 'pointer' }}
                                             onClick={(e) => {
                                                this.forget_pass(e);
                                             }}
                                          >
                                             {' '}
                                             Forgot Password
                                          </a>
                                       </p>
                                       <div className="mid-btns">
                                          <button
                                             className="login-btns"
                                             type="submit"
                                             disabled={this.state.disabled}
                                             // onClick={() => this.OnFormSubmit()}
                                          >
                                             Login
                                          </button>
                                       </div>
                                       <p className="reg-again text-center">
                                          <span className="page-login"> Don't have an account? </span>
                                          <Link to="/register">Click Here</Link>
                                       </p>
                                    </form>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </section>
            )}

            {!email_verified && (
               <div className='unVerified-section'>
                  <div className="unVerified-box">
                     <h6>
                        <img src={unverified_img} alt="unverified" />
                        Email verification required
                     </h6>
                     <p>
                        Your email address is not yet verified, Please check your registered email for the verification email (check you spam
                        too) and follow instructions to verify your account.
                     </p>
                     <div className="unVerified-btns">
                        <button className="btn resend-link" onClick={this.handleResendVerification}>
                           Resend verification link
                        </button>
                        <button
                           className="btn change-email"
                           onClick={() => {
                              this.setState({
                                 ackResendModal: true,
                                 email_verified: true,
                              });
                           }}
                        >
                           Change Email
                        </button>
                     </div>
                  </div>
               </div>
            )}

            {showResendModal && (
               <div className='unVerified-section'>
                  <div className="unVerified-box">
                     <h6>
                        <img src={tick_img} alt="sent" />
                        Verification email sent
                     </h6>
                     <p>
                        A verification email has been sent. Please check your registered email (including spam) and follow the instructions to verify your account.
                     </p>
                     <div className="unVerified-btns">
                        <button className="btn change-email" onClick={this.closeSent}>
                           Close
                        </button>
                     </div>
                  </div>
               </div>
            )}

            {ackResendModal && (
               <div className='unVerified-section'>
                  <div className="unVerified-box">
                     <h6>
                        <img src={unverified_img} alt="unverified" />
                        Alternate email address
                     </h6>
                     <p>Your email address is not yet verified. Please enter an alternative email address to verify your account.</p>
                     <Form className="new-form" onSubmit={this.handleSubmit}>
                        <FormGroup>
                           <Label className="form-label">Enter your new email address</Label>
                           <Input type="email" value={emailNew} onChange={this.handleChange} className="form-control" invalid={!!emailError} />
                           {emailError && <FormFeedback>{emailError}</FormFeedback>}
                        </FormGroup>
                        <Button type="submit" className="form-submit" color="primary" disabled={isDirty && !isValid}>
                           Submit
                        </Button>
                     </Form>
                  </div>
               </div>
            )}

            {ackNewEmail && (
               <div className='unVerified-section'>
                  <div className="unVerified-box">
                     <h6>
                        <img src={tick_img} alt="unverified" />
                        New email Updated
                     </h6>
                     <p>New email address is updated. please check and verifying your new email.</p>
                     <div className="unVerified-btns">
                        <button
                           className="btn change-email"
                           onClick={() => {
                              this.setState({
                                 ackResendModal: false,
                                 email_verified: true,
                                 ackNewEmail: false,
                                 showResendModal: false,
                              });
                           }}
                        >
                           Close
                        </button>
                     </div>
                  </div>
               </div>
            )}

            {spinner && <div className="spinner-box"><span className="spinner"></span></div>}

            <ToastContainer />
         </>
      );
   }
}

export default withRouter(CandidateLogin);
